module.exports = __webpack_public_path__ + "static/media/mini-moon-shot.4c25b568.png";